import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Shared UI Library Components
import { ITimezoneOption } from '@ppmcore/seven-ppm-core-shared-components-react';

// Models
import { ELocalStorageKeys } from "../../enums/storage.enums";
import { getBrowserTimezone } from "../../utils/getBrowserTimezone";

export interface IDateState {
  timezonesOptions: ITimezoneOption[],
  localTimezone: string | null,
  selectedTimezone: string | null,
  loading: boolean,
  showChangeTimeZoneModal: boolean;
}

// Identify browser time zone

const browserTimezone = getBrowserTimezone();

const initialState: IDateState = {
  timezonesOptions: [],
  localTimezone: browserTimezone, // First, initialization browser time zome
  selectedTimezone: browserTimezone, // Priority: saved -> browser
  loading: false,
  showChangeTimeZoneModal: false
};

export const dateSlice = createSlice({
  name: 'date',
  initialState,
  reducers: {
    setSelectedTimezone(state, { payload: timezone }: PayloadAction<string>) {
      state.selectedTimezone = timezone;
    },
    setLocalTimezone(state, { payload: timezone }: PayloadAction<string>) {
      state.localTimezone = timezone;
    },
    setTimezonesOptions(state, { payload: timezonesOptions }: PayloadAction<ITimezoneOption[]>) {
      state.timezonesOptions = timezonesOptions;
    },
    setShowChangeTimeZoneModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showChangeTimeZoneModal = payload;
    }
  }
});

export const DateSliceActions = dateSlice.actions;
